import IService from "./service";

export default class FormsService extends IService {

    getFormByLink(linkHash, request, consumer) {
        return this.$services.api.get('forms/link/' + linkHash, {
            params: {
                request: request,
                consumer: consumer
            }
        });
    }

    async getFormByCode(code) {
        return await this.$services.api.get('forms/code/' + code);
    }

    async getForPreview(formId) {
        return await this.$services.api.get('forms/' + formId + '/preview');
    }

    async sendForm(form) {
        let response = await this.$services.api.post('consumers/forms', form)
        return response.data;
    }

    async validateForm(form) {
        let response = await this.$services.api.post('consumers/forms/validate', form)
        return response.data;
    }
}